import { render, staticRenderFns } from "./albumCover.vue?vue&type=template&id=4bcc3ad0&scoped=true&"
import script from "./albumCover.vue?vue&type=script&lang=ts&"
export * from "./albumCover.vue?vue&type=script&lang=ts&"
import style0 from "./albumCover.vue?vue&type=style&index=0&id=4bcc3ad0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcc3ad0",
  null
  
)

export default component.exports